/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Check_In_Member_DescriptionInputs */

const en_check_in_member_description = /** @type {(inputs: Check_In_Member_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check in once per UTC day. Missed days pause your progress, so no reward is lost.`)
};

const es_check_in_member_description = /** @type {(inputs: Check_In_Member_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regístrate una vez al día UTC. Si faltas, tu progreso se pausa y no pierdes recompensas.`)
};

/**
* | output |
* | --- |
* | "Check in once per UTC day. Missed days pause your progress, so no reward is lost." |
*
* @param {Check_In_Member_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_member_description = /** @type {((inputs?: Check_In_Member_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_Member_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_member_description(inputs)
	return es_check_in_member_description(inputs)
});